"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var GSIconClipboard = function (props) { return ((0, jsx_runtime_1.jsxs)("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: [(0, jsx_runtime_1.jsx)("path", { d: "M20.5 18.376V6.343c0-.852-.693-1.545-1.544-1.545h-1.552V3.324h-2.25a3.128 3.128 0 0 0-2.31-2.249 3.192 3.192 0 0 0-2.73.599 3.164 3.164 0 0 0-1.094 1.65H6.77V4.8H5.045c-.852 0-1.545.692-1.545 1.545v15.124c0 .852.693 1.545 1.545 1.545h13.91c.852 0 1.546-.774 1.546-1.683H5.18V6.48H6.77v1.44h10.635V6.48h1.414v13.531l1.683-1.635ZM15.72 6.238H8.453V5.007h2.139v-.842a1.501 1.501 0 0 1 1.868-1.451c.661.155 1.123.751 1.123 1.451v.842h2.139v1.231Z", fill: "currentColor" }), (0, jsx_runtime_1.jsx)("path", { d: "M16.398 14.624H7.601v1.683h8.797v-1.682ZM16.398 17.568H7.601v1.683h8.797v-1.683Z", fill: "currentColor" })] }))); };
exports.default = GSIconClipboard;
